import { useEffect, useState } from 'react'
import { getAuthState, subscribe } from '@/lib/auth'

/** Trạng thái đăng nhập, tự cập nhật khi đổi phiên / đổi shop / lưu hồ sơ. */
export function useAuthState() {
  const [state, setState] = useState(getAuthState())
  useEffect(() => {
    const unsubscribe = subscribe(setState)
    return () => { unsubscribe() }
  }, [])
  return state
}
